export default __webpack_public_path__ + "static/media/cart.e6ad2ee2.png";